
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "12 AI pour créer son site internet - Créateur de site IA",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "La conception de sites web connaît aujourd'hui une transformation radicale grâce à l'avènement des créateurs de sites internet IA.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "12 AI pour créer son site internet - Créateur de site IA",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "La conception de sites web connaît aujourd'hui une transformation radicale grâce à l'avènement des créateurs de sites internet IA.",
        },
      ],
    };
  },
};
